const testimonials = [
  {
    name: "Darshan Kanade",
    role: "ML Engineer",
    text: "Responses were actually good... I came across things I didn't know could be useful.",
    linkedin: "https://www.linkedin.com/in/darshan-kanade-0797851b3/",
  },
  {
    name: "Meet Joshi",
    role: "Research Fellow",
    text: "Did not know I was looking for something exactly like this - faster than Googling each topic, and more structured than chatbots.",
    linkedin: "https://www.linkedin.com/in/meet-joshi-787148138/",
  },
  {
    name: "Adityan Nair",
    role: "Software Engineer",
    text: "Love the deep dive feature... it's helping me understand concepts better rather than simply copy pasting code from chat-based tools.",
    linkedin: "https://www.linkedin.com/in/adityan-nair-0967/",
  },
  {
    name: "Darshan Bhavsar",
    role: "ML Engineer",
    text: "The way DeepNode organizes outputs has made my learning process much more efficient. Absolutely love it!",
    linkedin: "https://www.linkedin.com/in/darshan01/",
  },
  {
    name: "Ok_Comedian_4676",
    role: "reddit user",
    text: "Great tool. I used it trying to find something to give you some feedback or recommendations, but I failed: the tool is impressive just the way it is. I really like it, and love the UI.",
    linkedin: "https://www.reddit.com/r/SideProject/comments/1ht8paj/comment/m5c9s27/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button",
  }
  // {
  //   name: "David",
  //   role: "Writer",
  //   text: "'You can't search what you don't know' - that's exactly what DeepNode helps me with. And Dive Deep feature works like a charm!",
  //   linkedin: "https://www.linkedin.com/in/david-writer/",
  // },
];

const TestimonialsScroll = () => {
  return (
    <div className="testimonials-container">
      <div className="testimonials-inner">
        <h2 className="testimonials-title">What people are saying</h2>

        <div className="scroll-container">
          <div className="gradient-overlay left" />
          <div className="gradient-overlay right" />

          <div className="scroll-wrapper">
            <div className="scroll-content">
              {[...testimonials, ...testimonials].map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <p className="testimonial-text">{testimonial.text}</p>
                  <div className="testimonial-author">
                    {/* Profile Picture Placeholder */}
                    {/* <img
                      src="https://via.placeholder.com/48"
                      alt={`${testimonial.name}'s profile`}
                      className="author-image"
                    /> */}
                    <div className="author-info">
                      <a
                        href={testimonial.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="author-link"
                      >
                        <p className="author-name">{testimonial.name}</p>
                        <p className="author-role">{testimonial.role}</p>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .testimonials-container {
          width: 100%;
          padding: 3rem 0;
          min-height: 600px;
          display: flex;
          flex-direction: column;
          margin-bottom: -10rem;
        }

        .testimonials-inner {
          max-width: 100%;
          margin: 0;
          padding: 0 1rem;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        .testimonials-title {
          font-size: clamp(24px, 4vw, 36px);
          font-weight: 400;
          text-align: center;
          color: white;
          margin-bottom: -8rem;
        }

        .scroll-container {
          position: relative;
          overflow: hidden;
          flex-grow: 1;
          display: flex;
          align-items: center;
        }

        .gradient-overlay {
          position: absolute;
          top: 0;
          height: 100%;
          width: 5rem;
          z-index: 10;
        }

        .scroll-wrapper {
          display: flex;
          overflow: hidden;
          height: 100%;
        }

        .scroll-content {
          display: flex;
          animation: scroll 40s linear infinite;
          align-items: center;
        }

        .scroll-content:hover {
          animation-play-state: paused;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .testimonial-card {
          flex-shrink: 0;
          width: 22rem;
          height: auto;
          margin: 0 0.75rem;
          background-color: #141414;
          border-radius: 1rem;
          padding: 2rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .testimonial-text {
          color: #fff;
          margin-bottom: 1rem;
          text-align: left;
          font-size: 1rem;
          line-height: 1.5;
          flex-grow: 1;
        }

        .testimonial-author {
          display: flex;
          align-items: center;
          margin-top: auto;
        }

        .author-image {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 1rem;
          object-fit: cover;
        }

        .author-info {
          margin-left: 0.5rem;
        }

        .author-link {
          text-decoration: none;
          color: inherit;
        }

        .author-link:hover .author-name {
          text-decoration: underline;
        }

        .author-name {
          font-size: 0.875rem;
          font-weight: 500;
          color: #fff;
          text-align: left;
        }

        .author-role {
          font-size: 0.75rem;
          color: #ccc;
          text-align: left;
          margin-top: -0.25rem;
        }
      `}</style>
    </div>
  );
};

export default TestimonialsScroll;
